import React, { Component } from "react";
import Layout from "layouts/DashboardManage";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Pagination from "components/Pagination";
import ManageDataTable from "components/ManageDataTable";
import { SpinnerRainbow } from "components/Spinner";
import ManageFilters from "../Forms/Elements/SearchManageComponents";
import NoData from "../NoData";
import {
  getAllMetadata,
  deleteMetadata,
  resetPayload,
  DELETE_METADATA
} from "store/actions/metadataAction";
import Notification, { notifyApiError } from "components/Notification";
import Translate from "helpers/Translate";

export class Metadata extends Component {
  state = {
    showDeleteConfirm: false
  };

  componentDidMount() {
    this.props.getAllMetadata({});
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      notifyApiError(this.props.error);
    }

    if (this.props.deleteStatus === 200) {
      Notification.success(Translate({ id: "data_deleted_successfully" }));
      this.props.resetPayload(DELETE_METADATA);
      this.props.getAllMetadata({ page: 1 });
    }
  }

  handleDelete = (e, item) => {
    e.preventDefault();
    const id = e.currentTarget.id || item.id;
    Notification.confirm(
      Translate({ id: "sure_to_delete", values: [item.title] }),
      {
        onOk: () => {
          this.props.deleteMetadata(id);
        }
      }
    );
  };

  onPageChange = data => {
    let selectedPage = parseInt(data.selected) + 1;
    this.props.getAllMetadata({ page: selectedPage });
  };

  hasData = () => {
    return (
      !this.props.isLoading &&
      this.props.metadata &&
      this.props.metadata.data &&
      this.props.metadata.data.length > 0
    );
  };

  render() {
    return (
      <Layout>
        <div className="manage">
          <Link className="back mb-20" to="/manage">
            <i className="fas fa-long-arrow-alt-left"></i>
            {Translate({ id: "back_to_manage_dashboard" })}
          </Link>

          <div className="manage-page-heading">
            <span className="manage-page-icon tone-orange" aria-hidden="true">
              <i className="fas fa-scroll"></i>
            </span>
            <div className="manage-page-heading__text">
              <h1 className="title">
                {Translate({ id: "manage_meta_data" })}
              </h1>
              <p className="manage-page-subtitle">
                {Translate({ id: "manage_meta_data_description" })}
              </p>
            </div>
          </div>
          <div className="manage-list-actions">
            <div className="search-metadata-data">
              <ManageFilters
                id="search-metadata"
                getAllData={getAllMetadata}
                placeholder="Search Metadata"
                propertyField="title"
                propertyValue="title"
              />
            </div>
            <Link
              className="btn btn-primary btn-add-manage"
              to="/manage/metadata/add"
              data-test="add_button"
            >
              <i className="fas fa-plus mr-10"></i>
              {Translate({ id: "add_meta_data" })}
            </Link>
          </div>

          {this.props.isLoading && <SpinnerRainbow />}

          {!this.props.isLoading && (
            <ManageDataTable
              footer={
                this.hasData() ? (
                  <Pagination
                    onPageChange={this.onPageChange}
                    data={this.props.metadata && this.props.metadata.meta}
                  />
                ) : null
              }
            >
              <table>
                <thead>
                  <tr>
                    <th className="left">{Translate({ id: "title" })} </th>
                    <th className="left">
                      {Translate({ id: "machine_learning_document_type" })}{" "}
                    </th>
                    <th className="left">
                      {Translate({ id: "client_document_type" })}{" "}
                    </th>
                    <th className="action-col">
                      {Translate({ id: "action" })}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.hasData() &&
                    this.props.metadata.data.map(item => (
                      <tr key={item.id}>
                        <td>{item.title}</td>
                        <td>{item.machine_learning_label}</td>
                        <td>{item.client_label}</td>
                        <td className="action-col">
                          <div className="manage-data-table-actions">
                            <Link
                              className="action-btn action-edit"
                              title={Translate({ id: "edit" })}
                              to={`/manage/metadata/edit/${item.id}`}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                            <button
                              type="button"
                              className="action-btn action-delete"
                              title={Translate({ id: "delete" })}
                              id={item.id}
                              onClick={e => this.handleDelete(e, item)}
                            >
                              <i className="fas fa-trash-alt" id={item.id}></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  {!this.hasData() && (
                    <tr>
                      <td colSpan="100">
                        <NoData />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </ManageDataTable>
          )}
        </div>
      </Layout>
    );
  }
}

Metadata.propTypes = {
  getAllMetadata: PropTypes.func.isRequired,
  metadata: PropTypes.object,
  isLoading: PropTypes.bool,
  deleteStatus: PropTypes.number,
  error: PropTypes.object
};

const mapStateToProps = state => {
  return {
    metadata: state.metadata.getAllMetadata,
    isLoading: state.metadata.isLoadingMetadata,
    deleteStatus: state.metadata.deleteMetadataStatus,
    error: state.metadata.errorMetadata
  };
};

export default connect(mapStateToProps, {
  getAllMetadata,
  deleteMetadata,
  resetPayload
})(Metadata);
